export interface State {}

export default function reducer(state = {}, _action?: unknown) {
  return state;
}
